import { flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import { SelectListModel } from "../share";
import { PaginationModel } from "../share/PagingModel";
import orgAPI from "./OrgService";

const OrganizeSummaryModel = types
  .model("OrganizeSummaryModel", {
    organization: customtypes.optional(SelectListModel, {}),
    ministry: customtypes.optional(types.string, ""),
    orgStatus: customtypes.optional(types.array(types.string), []),
    status: customtypes.optional(types.string, ""),
    error: types.optional(ErrorModel, {}),
  })
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    },
  }));
export type IOrganizeSummaryModel = typeof OrganizeSummaryModel.Type;

export const OrganizeListModel = types
  .model("OrganizeListModel", {
    orgTypeCode: types.optional(types.string, ""),
    lawTypeCode: types.optional(types.string, ""),
    FinancelTypeCode: types.optional(types.string, ""),
    list: types.optional(types.array(OrganizeSummaryModel), []),
    paging: types.optional(PaginationModel, {
      pageSize: 10,
    }),
    error: types.optional(ErrorModel, {}),
    loading: types.optional(types.boolean, false),
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    getOrganizeList: flow(function* () {
      try {
        self.loading = true;
        const result = yield orgAPI.getOrganizeList({
          orgTypeCode: self.orgTypeCode,
          lawTypeCode: self.LawTypeCode,
          financelTypeCode: self.FinancelTypeCode,
          paging: self.paging,
        });
        self.list = result.data;
        self.setPagination(result);
      } catch (e) {
        self.error.tigger = true;
        self.error.code = e.code;
        self.error.title = e.name;
        self.error.message = e.message;
        self.error.technicalStack = e.technicalStack;
        throw e;
      } finally {
        self.loading = false;
      }
    }),
    loadOrganizeList: flow(function* (searchText?: string) {
      try {
        self.loading = true;
        self.orgTypeCode = "";
        self.LawTypeCode = "";
        self.FinancelTypeCode = "";
        if (searchText) {
          self.paging.searchText = searchText;
        }
        const result = yield orgAPI.getOrganizeList({
          orgTypeCode: self.orgTypeCode,
          paging: self.paging,
        });
        self.list = result.data;
      } catch (e) {
        console.log(e);
      } finally {
        self.loading = false;
      }
    }),
    setOrgTypeCode: (orgTypeCode: string) => {
      self.orgTypeCode = orgTypeCode;
    },
    onSelectedFilter: (value: any) => {
      self.setDefaultPagination();
      self.orgTypeCode = value;
      self.getOrganizeList();
    },
    onSelectedLawtypeFilter: (value: any) => {
      self.setDefaultPagination();
      self.LawTypeCode = value; // อัปเดตค่า LawTypeCode
      self.getOrganizeList(); // เรียก API ใหม่
    },
    onSelectedFinancelFilter: (value: any) => {
      self.setDefaultPagination();
      self.FinancelTypeCode = value; // อัปเดตค่า LawTypeCode
      self.getOrganizeList(); // เรียก API ใหม่
    },
    onSearchTextFilter: (value: any) => {
      self.setDefaultPagination();
      self.paging.searchText = value;
      self.getOrganizeList();
    },
    onSelectedPage: (pageNo: number) => {
      self.paging.pageNo = pageNo;
      self.getOrganizeList();
    },
    setPagination: (result: any) => {
      self.paging.pageSize = result.pageSize;
      self.paging.pageNo = result.pageNo;
      self.paging.totalRow = result.totalRow;
    },
    setDefaultPagination: () => {
      self.paging.pageNo = 1;
    },
    resetAll: () => {
      self.list = [];
      self.paging = {
        pageSize: 10,
      };
    },
  }));

export type IOrganizeListModel = typeof OrganizeListModel.Type;
